import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store, select } from '@ngrx/store';
import * as userSelectors from '@nx-ratenow/core/data-access-user';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.pipe(
      select(userSelectors.isLoggedIn),
      switchMap((userLogged) => {
        if (!userLogged) {
          this.router.navigate(['auth'], {
            queryParams: { ...route.queryParams, returnUrl: state.url }
          });
          return of(false);
        }

        return of(true);
      }),
      catchError(() => of(false))
    );
  }
}
